import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { HelpCircle, Check } from 'lucide-react';
import * as Popover from '@radix-ui/react-popover';
import { cn } from '@/lib/cn';
import { useActiveMembership } from '@/features/session/useActiveMembership';
import { useTourStore } from './store';
import { TOURS } from './tours';
import { visibleTours } from './types';

export function HelpMenu() {
  const { t } = useTranslation('tour');
  const [open, setOpen] = useState(false);
  const { completed, startTour } = useTourStore();
  const { membership } = useActiveMembership();
  const tours = visibleTours(TOURS, membership?.role);

  return (
    <Popover.Root open={open} onOpenChange={setOpen}>
      <Popover.Trigger asChild>
        <button
          type="button"
          data-tour="topbar-help"
          className="grid h-8 w-8 place-items-center border border-border text-muted hover:bg-surface-2"
          aria-label={t('help.menuLabel')}
        >
          <HelpCircle size={16} />
        </button>
      </Popover.Trigger>
      <Popover.Portal>
        <Popover.Content align="end" sideOffset={6} className="z-50 w-64 border border-border bg-surface p-1.5 shadow-md">
          <div className="px-2 py-1.5 text-xs font-bold uppercase tracking-wide text-muted">{t('help.menuTitle')}</div>
          {tours.map((tour) => {
            const isDone = completed.includes(tour.id);
            return (
              <button
                key={tour.id}
                type="button"
                onClick={() => {
                  setOpen(false);
                  startTour(tour.id);
                }}
                className={cn(
                  'flex w-full items-center justify-between px-2.5 py-2 text-left text-sm hover:bg-surface-2',
                )}
              >
                <span className="text-ink">{t(tour.nameKey)}</span>
                {isDone ? <Check size={14} className="text-accent-ink" /> : null}
              </button>
            );
          })}
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
}
